import { render, staticRenderFns } from "./ExamTitlesNotesTable.vue?vue&type=template&id=ba2a2574"
import script from "./ExamTitlesNotesTable.vue?vue&type=script&lang=js"
export * from "./ExamTitlesNotesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports